module.exports = __webpack_public_path__ + "static/media/share.3014910f.svg";